import { Component, Input, OnInit } from '@angular/core';
import { AnalyticsService } from '../services/fb-analytics.service';
import { SocialLinks } from '../interfaces/socialLinks';

@Component({
  selector: 'app-social',
  templateUrl: './social.component.html',
  styleUrl: './social.component.scss'
})
export class SocialComponent implements OnInit {
  @Input() heading: string;
  @Input() subheading: string;
  @Input() enabled: string;
  @Input() iconColor: string = 'tan';

  links: SocialLinks[];
  isDarkMode: boolean;

  constructor(public analyticsService: AnalyticsService) {}

  handleDarkMode(): void {
    const dmStr = '(prefers-color-scheme: dark)',
          media = window.matchMedia(dmStr);

    media.removeEventListener('change', this.handleDarkMode);
    media.addEventListener('change', this.handleDarkMode);

    this.isDarkMode = window.matchMedia && media.matches;
  }

  getLinks(): SocialLinks[] {
    this.handleDarkMode();
    
    const links = [
      {
        id: 'linkedin',
        url: 'https://www.linkedin.com/in/nickhudson1',
        name: 'LinkedIn',
        image: `../../../../assets/images/linkedin-${this.iconColor}-001${this.isDarkMode ? '_dm' : ''}.svg`
      },
      {
        id: 'twitter',
        url: 'https://x.com/NickHudson86',
        name: 'X',
        image: `../../../../assets/images/x-${this.iconColor}-001${this.isDarkMode ? '_dm' : ''}.svg`
      },
      {
        id: 'instagram',
        url: 'https://www.instagram.com/nickhudsondev/',
        name: 'Instagram',
        image: `../../../../assets/images/instagram-${this.iconColor}-001${this.isDarkMode ? '_dm' : ''}.svg`
      },
      {
        id: 'behance',
        url: 'https://www.behance.net/nickhudson86',
        name: 'Behance',
        image: `../../../../assets/images/behance-${this.iconColor}-001${this.isDarkMode ? '_dm' : ''}.svg`
      },
      {
        id: 'resume',
        url: 'https://nhdsgn.com/assets/web-apps/resume.pdf',
        name: 'Resume',
        image: `../../../../assets/images/resume-${this.iconColor}-001${this.isDarkMode ? '_dm' : ''}.svg`
      }
    ];
    
    if (!this.enabled)
      return links;

    return links.filter(e => this.enabled.split(/\s*,\s*/).includes(e.id))
  }

  ngOnInit(): void {
    // this.handleDarkMode();
  }
}
